import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

async function getRegistration() {
  const reg = await navigator.serviceWorker.getRegistration();
  if (reg) return reg;
  return navigator.serviceWorker.register("/sw.js");
}

// Request permission, subscribe, and store the subscription on the backend.
export async function enablePush(token) {
  if (!pushSupported()) throw new Error("unsupported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");

  const reg = await getRegistration();
  await navigator.serviceWorker.ready;

  const { data } = await axios.get(`${API}/push/public-key`);
  const key = data.publicKey;
  if (!key) throw new Error("no-key");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(key),
    });
  }
  const json = sub.toJSON();
  await axios.post(
    `${API}/push/subscribe`,
    { endpoint: json.endpoint, keys: json.keys },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return true;
}

export async function sendPushTest(token) {
  await axios.post(`${API}/push/test`, {}, { headers: { Authorization: `Bearer ${token}` } });
}

// Keep the app icon badge in sync while the app is open.
export async function syncBadge(count) {
  try {
    if (count > 0 && navigator.setAppBadge) await navigator.setAppBadge(count);
    else if (navigator.clearAppBadge) await navigator.clearAppBadge();
  } catch (e) { /* unsupported */ }
}

// If permission already granted, (re)subscribe silently so a new device/login gets pushes.
export async function ensureSubscribed(token) {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  try { await enablePush(token); return true; } catch { return false; }
}
